import { render } from "./SoonView.vue?vue&type=template&id=4aa76cca"
import script from "./SoonView.vue?vue&type=script&lang=js"
export * from "./SoonView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__